module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', [_c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Name",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.name),
      callback: function($$v) {
        _vm.$set(_vm.row, "name", $$v)
      },
      expression: "row.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Incr. Per Year",
      "min": 0,
      "max": 100,
      "suffix": "%",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.percentIncreasePerYear),
      callback: function($$v) {
        _vm.$set(_vm.row, "percentIncreasePerYear", $$v)
      },
      expression: "row.percentIncreasePerYear"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f48efa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/rates/actions/TenancyRateDetails.vue
// module id = 1524
// module chunks = 0